import cashIcon from '../assets/icons/cash-prize.png';
import chestIcon from '../assets/icons/chest-reward.png';
import freeBetIcon from '../assets/icons/free-bet.png';
import freeSpinsIcon from '../assets/icons/free-spins.png';
import IcePuzzleIcon from '../assets/icons/ice-puzzle-piece.png';
import bonusIcon from '../assets/icons/instant-bonus.png';
import prizeGameIcon from '../assets/icons/prize-games.png';
import starsCoinIcon from '../assets/icons/stars-coin.png';
import tournamentMoneyIcon from '../assets/icons/tournament-money.png';
import tournamentTicketIcon from '../assets/icons/tournament-ticket.png';
// Chest 2.0 related
import defaultChestSprite from '../assets/images/default-chest-sprite.png';
import foxBetChestSprite from '../assets/images/foxbet-chest-sprite.png';
import pspcChestSprite from '../assets/images/pspc-chest-sprite.png';
import stadiumChestSprite from '../assets/images/stadium-chest-sprite.png';
import vaultChestSprite from '../assets/images/vault-chest-sprite.png';
// Chest 2.0 logos
import betStarsChestLogo from '../assets/logos/mpc-plaque-betstars.png';
import casinoChestLogo from '../assets/logos/mpc-plaque-casino.png';
import defaultChestLogo from '../assets/logos/mpc-plaque-default.png';
import eptChestLogo from '../assets/logos/mpc-plaque-ept.png';
import foxBetChestLogo from '../assets/logos/mpc-plaque-fox-bet.png';
import fullTiltChestLogo from '../assets/logos/mpc-plaque-fulltilt.png';
import millionaireChestLogo from '../assets/logos/mpc-plaque-millionaire.png';
import pokerStarsChestLogo from '../assets/logos/mpc-plaque-pokerstars.png';
import scoopChestLogo from '../assets/logos/mpc-plaque-scoop.png';
import starsFirstChestLogo from '../assets/logos/mpc-plaque-stars-first.png';
import starsRewardsChestLogo from '../assets/logos/mpc-plaque-stars-rewards.png';
import twitchChestLogo from '../assets/logos/mpc-plaque-twitch.png';
import wcoopChestLogo from '../assets/logos/mpc-plaque-wcoop.png';

export enum ActionType {
  Primary = 'Primary',
  Secondary = 'Secondary'
}

export enum FormatType {
  Date = 'Date',
  DateTime = 'Datetime',
  Number = 'Number',
  Currency = 'Currency'
}

export enum NotificationType {
  BonusBase = 'Bonus',
  BonusCleared = 'Bonus.cleared',
  BonusExpiring = 'Bonus.expiring',
  BonusIssued = 'Bonus.issued',
  ChestRewardAvailable = 'ChestReward.available',
  ChestRewardBase = 'ChestReward',
  ChestRewardIceLocked = 'ChestReward.icelocked',
  ChestRewardMultiple = 'ChestReward.multiple',
  ChestRewardTimeLocked = 'ChestReward.timelocked',
  FixedPrizeDrawBase = 'FixedPrizeDraw',
  FixedPrizeDrawIssued = 'FixedPrizeDraw.issued',
  FixedPrizeDrawLost = 'FixedPrizeDraw.lost',
  FixedPrizeDrawWon = 'FixedPrizeDraw.won',
  FreeSpinsBase = 'FreeSpins',
  FreeSpinsExpiring = 'FreeSpins.expiring',
  FreeSpinsIssued = 'FreeSpins.issued',
  InstantBonusSplitWager = 'InstantBonusSplitWager',
  MiniGameTicket = 'MiniGameTicket',
  NotificationError = 'NotificationError'
}

enum FixedPrizeDrawType {
  NoPrize = 0,
  RealMoney,
  PlayMoney,
  Fpp,
  Ticket,
  MiniGame,
  JackPot,
  CasinoRoll,
  RewardPoints,
  TChips,
  GameTicket,
  FreeSpins,
  FreeSportsBet,
  IcePuzzle,
  MPC,
  TournamentTickets,
  GiftCode
}

export const FixedPrizeImageIconMap = {
  [FixedPrizeDrawType.RealMoney]: cashIcon,
  [FixedPrizeDrawType.PlayMoney]: cashIcon,
  [FixedPrizeDrawType.Fpp]: starsCoinIcon,
  [FixedPrizeDrawType.Ticket]: tournamentTicketIcon,
  [FixedPrizeDrawType.MiniGame]: prizeGameIcon,
  [FixedPrizeDrawType.JackPot]: cashIcon,
  [FixedPrizeDrawType.CasinoRoll]: bonusIcon,
  [FixedPrizeDrawType.RewardPoints]: starsCoinIcon,
  [FixedPrizeDrawType.TChips]: tournamentMoneyIcon,
  [FixedPrizeDrawType.GameTicket]: prizeGameIcon,
  [FixedPrizeDrawType.FreeSpins]: freeSpinsIcon,
  [FixedPrizeDrawType.FreeSportsBet]: freeBetIcon,
  [FixedPrizeDrawType.IcePuzzle]: IcePuzzleIcon,
  [FixedPrizeDrawType.MPC]: chestIcon,
  [FixedPrizeDrawType.TournamentTickets]: tournamentTicketIcon,
  [FixedPrizeDrawType.GiftCode]: chestIcon
};

export enum ChestAssetType {
  Invalid = 0,
  ChestSkin,
  Podium,
  Background,
  Logo,
  NotificationHeader
}

export const ChestAssetName = {
  [ChestAssetType.Invalid]: '',
  [ChestAssetType.Podium]: 'podium',
  [ChestAssetType.Background]: 'background',
  [ChestAssetType.ChestSkin]: 'chestskin',
  [ChestAssetType.Logo]: 'logo',
  [ChestAssetType.NotificationHeader]: 'notificationheader'
};

export const LegacyChestSpriteMap = {
  default: defaultChestSprite,
  mpc: defaultChestSprite,
  foxbet: foxBetChestSprite,
  vault: vaultChestSprite,
  stadium: stadiumChestSprite,
  christmas: defaultChestSprite,
  pspc: pspcChestSprite
};

export const LegacyChestLogoMap = {
  none: '',
  default: defaultChestLogo,
  stars_first: starsFirstChestLogo,
  millionaire: millionaireChestLogo,
  casino: casinoChestLogo,
  betstars: betStarsChestLogo,
  twitch: twitchChestLogo,
  ept: eptChestLogo,
  stars_rewards: starsRewardsChestLogo,
  full_tilt: fullTiltChestLogo,
  scoop: scoopChestLogo,
  wcoop: wcoopChestLogo,
  soccer_red: defaultChestLogo,
  soccer_blue: defaultChestLogo,
  soccer_brown: defaultChestLogo,
  soccer_silver: defaultChestLogo,
  soccer_gold: defaultChestLogo,
  soccer_platinum: defaultChestLogo,
  ufc: defaultChestLogo,
  pirate: defaultChestLogo,
  pspc: defaultChestLogo,
  poker: pokerStarsChestLogo,
  fox_bet: foxBetChestLogo
};

export enum InstantBonusClearanceType {
  Points = 'points',
  Bets = 'bets',
  Funds = 'funds'
}
